import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: stretch;
`;

export const Footer = styled.div`
  display: inline-grid;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  grid-template-columns: auto auto;
  grid-gap: 15px;

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 175px;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;

  ${Media.lg`
    flex-direction: column;
  `}
`;

export const Aside = styled.div`
  display: block;
  width: 100%;
  max-width: 276px;
  padding: 40px 20px 0 0;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    max-width: initial;
    padding: 20px 10px;
  `}
`;

export const Main = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
  padding: 40px 40px 20px 20px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    padding: 20px 10px;
    overflow: initial;
  `}
`;

export const MainInner = styled.div`
  display: block;
  width: 100%;
`;

export const Subtitle = styled.h3`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 700;
  cursor: default;
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 5px;
`;

export const Row = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 85px repeat(4, 1fr) 85px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.head &&
    css`
      border-radius: 0;

      ${Media.xlg`
        display: none;
      `}
    `}

  ${Media.xlg`
    grid-template-columns: 1fr;
  `}
`;

export const Cell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px;
  color: ${(props) => props.theme.color};
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  word-break: break-all;
  cursor: default;

  ${(props) =>
    props.head &&
    css`
      padding: 10px 15px 0;
      border-radius: 0;
      font-weight: 700;
    `}

  ${(props) =>
    props.right &&
    css`
      justify-content: flex-end;

      ${Media.xlg`
        justify-content: center;
      `}
    `}

    ${(props) =>
    props.active &&
    css`
      color: ${(props) => props.theme.colorOnActive};
    `}

  ${Media.xlg`
    gap: 5px;
  `}
`;

export const Label = styled.span`
  width: 50%;
`;

export const Value = styled.span`
  width: 50%;
`;

export const ActionButton = styled.button`
  ${commonButton}
`;

export const ActionButtonIcon = styled.i``;

export const Strong = styled.strong`
  ${commonStrong}
`;

export const DateLabel = styled.span`
  font-weight: 400;
  * {
    margin-right: 5px;
  }
`;

export const MoreBar = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const More = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  transition: 0.2s color;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const MoreIcon = styled.i``;

export const AvatarHolder = styled.div`
  display: flex;
  width: 55px;
  height: 55px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  border: 2px solid ${(props) => props.theme.border};
  overflow: hidden;
`;

export const Avatar = styled.img`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  background: ${(props) => props.theme.background};
`;

export const AvatarPlaceholder = styled.div`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  background: ${(props) => props.theme.background};
`;

export const Inputbox = styled.div`
  ${commonInputbox}
  margin-bottom: 15px;
`;

export const Input = styled.input`
  ${commonInput}
`;

export const Deco = styled.span`
  ${commonStrong}
  margin-left: 10px;
  color: ${(props) => props.theme.color};
`;

export const SortSign = styled.span`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  color: ${(props) => props.theme.color};
  cursor: pointer;
  overflow: hidden;

  ${(props) =>
    props.active &&
    css`
      color: ${(props) => props.theme.colorOnActive};
    `}
`;

export const SortSignIcon = styled.i`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.2.0rem;
  user-select: none;

  &:first-of-type {
    padding-bottom: 8px;
  }

  &:last-of-type {
    padding-top: 8px;
  }
`;
